<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="desserts"
      :search="search"
      sort-by="id"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Огранизации</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="search"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" @click="AddOrganisation"
            ><v-icon left>add</v-icon>Добавить организацию в Finexpert</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon normal class="mr-2" @click="editItem(item)">edit </v-icon>
        <v-icon normal class="mr-2" @click="users(item)">people </v-icon>
        <v-icon normal class="removes" @click="showRemoveOrg(item)"
          >delete_forever</v-icon
        >
      </template>
    </v-data-table>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="deep-purple accent-4"
    ></v-progress-linear>
    <v-row justify="center">
      <v-dialog v-model="removeDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline" style="margin: 0 auto; color: #e53935"
              >Удалить данную организацию</span
            >
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col v-if="selectedOrg !== null">
                  <p>ИНН: {{ selectedOrg.inn }}</p>
                  <p>КПП: {{ selectedOrg.kpp }}</p>
                  <p>ОГРН: {{ selectedOrg.ogrn }}</p>
                  <p>Наименование: {{ selectedOrg.orgName }}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="removeDialog = false">
              Отменить
            </v-btn>
            <v-btn color="red darken-1" text @click="removeOrganization">
              Удалить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<style scoped lang='sass'>
.remove
  cursor: pointer
  &:hover
    color: red
</style>

<script>
export default {
  data: () => ({
    search: "",
    dialog: false,
    loading: false,
    removeDialog: false,
    headers: [
      {
        text: "Название",
        align: "left",
        sortable: false,
        value: "orgName",
      },
      { text: "ИНН", value: "inn" },
      { text: "КПП", value: "kpp" },
      { text: "ОГРН", value: "ogrn" },
      { text: "Действия", value: "action", sortable: false },
    ],
    selectedOrg: null,
  }),
  async mounted(){
    await this.$store.dispatch("GetUserManagementSettingsFinexpert")
  },
  computed: {
    desserts() {
      return this.$store.getters.GetOrganisationsUMFinexpert;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize()
  },

  methods: {
    getBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
    getColor(color) {
      if (color) return "red";
      return "transparent";
    },
    showRemoveOrg(org) {
      this.removeDialog = true;
      this.selectedOrg = org;
    },
    async removeOrganization() {
      await this.$store.dispatch("removeOrganization", this.selectedOrg);
      await this.$store.dispatch("GetUserManagementSettingsFinexpert");
      this.removeDialog = false;
    },
    AddOrganisation() {
      this.$router.push("/addorganisation?redirect=adminpanelfinexpert");
    },

    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true
      if (!item.pravForm) {
        if (item.inn.length == 10) {
          item.pravForm = "1";
        }
        if (item.inn.length == 12) {
          item.pravForm = "2";
        }
      }
      this.loading = true;
      this.$store
        .dispatch("getOrganisationUM", item)
        .then(() => {
          this.loading = false;
          this.$router.push("/editorganisation?redirect=adminpanelfinexpert");
        })
        .catch((error) => {
          this.loading = false;
          alert(error);
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },

    users(item) {
      this.loading = true;
      this.$store
        .dispatch("getUsersOfOrganisation", item)
        .then(() => {
          this.loading = false;

          this.$router.push("/usersorganisationtable?redirect=adminpanelfinexpert");
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
};
</script>
